const state = {
  id: "000000000000000000",
  username: "User",
  discriminator: "0000",
  guilds: [],
  avatar: null,
  authenticated: false,
  beta_features: [],
  verified_email: false,
  token: null,
  queried: false
};

const getters = {
  id: () => state.id,
  username: () => state.username,
  discriminator: () => state.discriminator,
  guilds: () => state.guilds,
  avatar: () => state.avatar,
  authenticated: () => state.authenticated,
  beta_features: () => state.beta_features,
  verified_email: () => state.verified_email,
  bearer_token: () => state.token,
  login_queried: () => state.queried
};

const actions = {
  storeToken (action, token) {
    return action.commit("mutateToken", token);
  },
  storeUser (action, user) {
    return action.commit("mutateUser", user);
  },
  resetUser (action) {
    return action.commit("resetUser", null);
  },
  markLoginAsQueried (action) {
    return action.commit("markLoginAsQueried", null);
  }
};

const mutations = {
  mutateToken (state, token) {
    state.token = token;
  },
  mutateUser (state, user) {
    state.id = user.id;
    state.username = user.username;
    state.discriminator = user.discriminator;
    state.guilds = user.guilds;
    state.avatar = user.avatar;
    state.authenticated = true;
    state.beta_features = user.beta_features;
    state.verified_email = user.verified_email;
  },
  resetUser (state) {
    state.id = "000000000000000000";
    state.username = "User";
    state.discriminator = "0000";
    state.guilds = [];
    state.avatar = null;
    state.authenticated = false;
    state.beta_features = [];
    state.verified_email = false;
  },
  markLoginAsQueried (state) {
    state.queried = true;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
